import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpModule, Request, XSRFStrategy } from '@angular/http';
import { AuthModule, AUTH_CONFIG, AuthConfig } from '@shared/auth';
import { CookieModule } from '@shared/cookie';

import { Tracking } from './tracking.service';
import { ErrorTracking } from './error-tracking.service';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingConfig } from './tracking.interface';
import { TrackingComponent } from './tracking.component';
import { TrackingDirective } from './tracking.directive';
import { TrackingSectionDirective } from './tracking-section.directive';
import { NavigationPerformanceTrackingComponent } from './navigation-performance-tracking.component';
import { UserTimingTrackingComponent } from './user-timing-tracking.component';
import { MemoryLeakTrackingComponent } from './memory-leak-tracking.component';
import { SyntheticPerformanceTrackingComponent } from './synthetic-performance-tracking.component';

export class NoXSRFStrategy {
  configureRequest(req: Request) {
    // Remove `x-xsrf-token` from request headers since the tracking backend
    // doesn't care, and it avoids uneeded CORS preflight requests
  }
}

@NgModule({
  imports: [HttpModule, AuthModule, CookieModule],
  declarations: [
    TrackingComponent,
    TrackingDirective,
    TrackingSectionDirective,
    NavigationPerformanceTrackingComponent,
    UserTimingTrackingComponent,
    MemoryLeakTrackingComponent,
    SyntheticPerformanceTrackingComponent,
  ],
  exports: [TrackingComponent, TrackingDirective, TrackingSectionDirective],
  providers: [
    ErrorTracking,
    { provide: XSRFStrategy, useClass: NoXSRFStrategy },
  ],
  // Exported to GAF
  entryComponents: [TrackingComponent],
})
export class TrackingModule {
  static initialize(config: TrackingConfig): ModuleWithProviders {
    return {
      ngModule: TrackingModule,
      providers: [Tracking, { provide: TRACKING_CONFIG, useValue: config }],
    };
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/tracking/tracking.module.ts